export default __webpack_public_path__ + "static/media/desktop_banner_health.08f6919e.jpg";